<div [hidden]="!showBanner" class="cf_log-in-out-banner">
	<div class="content">
		<div class="message">
			<div [hidden]="isInternal">
				<span class="emphasized">{{
					Loc(LocalizedTextIds.LogInOutBannerYouAreCurrently)
				}}</span>
				{{ Loc(LocalizedTextIds.LogInOutBannerNeedToGoBack) }}
			</div>
			<div [hidden]="!isInternal">
				<div [hidden]="!name">
					{{ Loc(LocalizedTextIds.LogInOutBannerAuthenticatedAs) }}
					<span class="emphasized">{{ name }}</span>
					{{ Loc(LocalizedTextIds.LogInOutBannerToInternalVersion) }}
				</div>
				<div [hidden]="name">
					{{
						Loc(
							LocalizedTextIds.LogInOutBannerAutheticatedToInternal
						)
					}}
				</div>
			</div>
		</div>
		<div>
			<div [hidden]="isInternal" class="action" (click)="login()">
				<div>{{ Loc(LocalizedTextIds.LogIn) }}</div>
			</div>
			<div [hidden]="!isInternal" class="action" (click)="logout()">
				<div>{{ Loc(LocalizedTextIds.LogOut) }}</div>
			</div>
		</div>
	</div>
</div>
